export default __webpack_public_path__ + "static/media/sdk-tools-icon.16bd8e22.svg";